import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAdminAccount } from 'src/lib/auth/roles';
import { useAuth } from 'src/lib/auth/use-auth';
import { DashboardHeader } from './DashboardHeader.component';
import { DashboardSideBar } from './DashboardSideBar.component';

export function DashboardContainer() {
  const { pathname } = useLocation();
  const { isAuthenticated, user, locationState } = useAuth('/admin/login');

  if (!isAuthenticated && pathname !== '/admin/login') {
    return <Navigate to="/admin/login" replace state={{ pathname }} />;
  }

  if (isAuthenticated && !isAdminAccount(user)) {
    return <Navigate to="/map" replace />;
  }

  if (isAuthenticated && (pathname === '/admin' || pathname === '/admin/login')) {
    return <Navigate to="/admin/areas" replace />;
  }

  return isAuthenticated ? (
    <>
      <DashboardHeader />
      <DashboardSideBar />
      <Outlet />
    </>
  ) : (
    <Outlet context={locationState} />
  );
}
